export const PROGRESS_CONSTANT = {
  SIGNIN: 'signUp',
  BASIC_INFO: 'basicInfoForm',
  ASSESSMENT: 'coreBasicsCompleted',
  LOGIC: 'crackedLogic',
  PERSONALITY: 'personalityRoundCompleted',
  PROFILE: 'profileCompleted',
  SHORTLISTED: 'shortlistedForJob',
  MATCH_FOUND: 'matchFound',
  HIRED: 'getHired'
};
